import { isKeycloak } from '@/utils/buildProfile';

/**
 * Keep-ON replacement for release-auth-auth0-social-login-google.
 * Auth0 Google social is allowed on cloud Auth0 builds only.
 * Forced off for Kinde override and Keycloak (on-prem) builds.
 */
export function isAuth0SocialLoginGoogleAllowed(): boolean {
  if (process.env.NEXT_PUBLIC_FORCE_KINDE === 'true') return false;
  if (isKeycloak) return false;
  return true;
}
